<template>
    <AdminNavbar />
    <main class="admin-content">
        <slot />
    </main>
</template>

<script setup lang="ts">
    import AdminNavbar from '~/components/admin/Navbar.vue';
</script>

<style lang="scss">
    .admin-content {
        padding: 0 var(--joy-core-spacing-6);
    }
</style>
